<template>
  <div class="ckeditor"><textarea :id="id" :value="value"></textarea></div>
</template>


<script>
var ckeditorClient = ''
var ckeditorxToken = ''
export default {
  name: 'ckeditor',
  props: {
    value: {
      type: String,
      default: ''
    },
    update: {
      type: Boolean,
      default: false
    },
    client: {
      type: String
    },
    xToken: {
      type: String
    },
    uploadImageUrl: {
      type: String
    },
    id: {
      type: String,
      default: 'editor'
    },
    height: {
      type: String,
      default: '90px'
    },
    toolbar: {
      type: Array,
      default: () => [{
        name: 'document',
        items: ['Print']
      },
      {
        name: 'clipboard',
        items: ['Undo', 'Redo']
      },
      {
        name: 'styles',
        items: ['Format', 'Font', 'FontSize']
      },
      {
        name: 'colors',
        items: ['TextColor', 'BGColor']
      },
      {
        name: 'align',
        items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock']
      },
      '/',
      {
        name: 'basicstyles',
        items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting']
      },
      {
        name: 'links',
        items: ['Link', 'Unlink']
      },
      {
        name: 'paragraph',
        items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote']
      },
      {
        name: 'insert',
        items: ['Image', 'Table']
      },
      {
        name: 'tools',
        items: ['Maximize']
      },
      {
        name: 'editing',
        items: ['Scayt']
      }
      ]
    },
    toolbarGroups: {
      type: Array,
      default: () => [
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
        { name: 'editing', groups: [ 'find', 'selection', 'spellchecker' ] },
        { name: 'links' },
        { name: 'insert' },
        { name: 'forms' },
        { name: 'tools' },
        { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
        { name: 'others' },
        '/',
        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
        { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi' ] },
        { name: 'styles' },
        { name: 'colors' },
        { name: 'about' }
      ]
    },
    language: {
      type: String,
      default: 'en'
    },
    extraplugins: {
      type: String,
      default: ''
    }
  },
  methods: {
    init () {
      const ckeditorId = this.id
      let ckeditorConfig = {
        toolbarGroups: this.toolbarGroups,
        extraAllowedContent: 'span;ul;li;table;td;style;*[id];*(*);center;h3{clear};h2{line-height};h2 h3{margin-left,margin-top}',

        // Adding drag and drop image upload.
        extraPlugins: 'print,format,font,colorbutton,justify',
        height: this.height,
        removeDialogTabs: 'image:advanced;link:advanced'
      }
      if (this.uploadImageUrl) {
        ckeditorConfig.uploadUrl = this.uploadImageUrl
        ckeditorConfig.filebrowserUploadUrl = this.uploadImageUrl
        ckeditorConfig.extraPlugins += ',uploadimage'
      }
      CKEDITOR.replace(ckeditorId, ckeditorConfig)
      CKEDITOR.instances[ckeditorId].setData(this.value)
      CKEDITOR.instances[ckeditorId].on('change', () => {
        let ckeditorData = CKEDITOR.instances[ckeditorId].getData()
        if (ckeditorData !== this.value) {
          this.$emit('input', ckeditorData)
        }
      })
      CKEDITOR.on('dialogDefinition', function (e) {
        if (e.data.name == 'image') {
          let dialog = e.data.definition,
            oldOnShow = dialog.onShow
          dialog.onShow = function () {
            oldOnShow.apply(this, arguments)
            this.selectPage('Upload')
          }
        }
      })
      CKEDITOR.instances[ckeditorId].on('instanceReady', (e) => {
        e.editor.on('fileUploadRequest', function (ev) {
          var xhr = ev.data.fileLoader.xhr
          xhr.setRequestHeader('Client', ckeditorClient)
          xhr.setRequestHeader('x-token', ckeditorxToken)
        })

        e.editor.on('fileUploadResponse', function (evt) {
          evt.stop()

          // Get XHR and response.
          let data = evt.data,
            xhr = data.fileLoader.xhr,
            response = xhr.responseText
          response = JSON.parse(response)

          if (!response.status) {
            data.message = response.message
            evt.cancel()
          } else {
            data.url = response.url
          }
        })
      })
    },
    destroy() {
      const ckeditorId = this.id
      if (CKEDITOR.instances[ckeditorId]) {
        CKEDITOR.instances[ckeditorId].destroy()
      }
    }
  },
  beforeUpdate () {
    const ckeditorId = this.id
    if (this.value !== CKEDITOR.instances[ckeditorId].getData()) {
      CKEDITOR.instances[ckeditorId].setData(this.value)
    }
  },
  mounted () {
    ckeditorClient = this.client
    ckeditorxToken = this.xToken
    this.init()
  },
  destroyed () {
    this.destroy()
  },
  watch: {
    update: function (val) {
      if (val) {
        this.destroy()
        this.init()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/editors/CKEditor.vue